<template>
  <b-button v-if="botao" @click="baixar" size="sm" :disabled="isDisabled">
    <font-awesome-icon :icon="icone" v-if="!loading" />
    <b-spinner small v-else />
    <span class="ml-2">{{ texto }}</span>
  </b-button>
  <b-link v-else class="text-dark" @click="baixar" :disabled="isDisabled">
    <font-awesome-icon :icon="icone" v-if="!loading" />
    <b-spinner small v-else />
    <span class="texto-botao">{{ texto }}</span>
  </b-link>
</template>

<script>
export default {
  name: "BtnDownloadComponent",
  props: {
    botao: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    fazerDownload: { type: Function, required: true },
    icone: { type: String, default: "download" },
    parametros: { required: false },
    texto: { type: String, default: "Download" },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isDisabled(){
      return this.disabled || this.loading
    }
  },
  methods: {
    async baixar() {
      this.loading = true;
      try {
        if (this.parametros) {
          if (Array.isArray(this.parametros)) {
            await this.fazerDownload(...this.parametros);
          } else {
            await this.fazerDownload(this.parametros);
          }
        } else {
          await this.fazerDownload();
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.text-dark.disabled>span,
.text-dark.disabled:hover {
  color: var(--gray);
  cursor: default;
  text-decoration: none;
}
</style>